import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import PanelTemplate from '../../common/PanelTemplate';
import ScoreCard from '../ScoreCard';

const useStyles = makeStyles(theme => ({
  scoreCardBody: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(0, 4, 3)
  }
}));

const ScoreCardPanel = props => {
  const {
    tier,
    installingSince,
    ensembleCertification,
    npsScore,
    sitesCount,
    invertersCount,
    storagesCount,
    period = 12,
    belongsToUs
  } = props;
  const classes = useStyles();
  return (
    <PanelTemplate header="Company Performance Scorecard" id="companyPerformanceScorecard">
      <Box className={classes.scoreCardBody}>
        <ScoreCard value={tier} label="Enphase Tier" icon="star" />
        <ScoreCard value={installingSince} label="Installing Enphase Since" icon="calender" />
        {belongsToUs && <ScoreCard value={ensembleCertification} label="Ensemble1.0 Certified" icon="bookmark" />}
        <ScoreCard value={npsScore} label="Net Promoter Score" icon="smiley" />
        <ScoreCard value={sitesCount} label="Sites Commissioned" period={period} icon="home" />
        <ScoreCard value={invertersCount} label="Microinverters installed" period={period} icon="energy" />
        <ScoreCard value={storagesCount} label="Batteries Installed" period={period} icon="battery" />
      </Box>
    </PanelTemplate>
  );
};

export default ScoreCardPanel;
